import { gql } from '@apollo/client'

export const USER_STATS_QUERY = gql`
  query userStats($isLegalAdvisor: Boolean = false, $isAdmin: Boolean = false) {
    userStats {
      acceptedCases @skip(if: $isAdmin) {
        category
        level
        message
      }
      firstCalls @skip(if: $isAdmin) {
        category
        level
        message
      }
      reminders @skip(if: $isAdmin) {
        category
        level
        message
      }
      pools {
        category
        level
        message
      }
      assignedLegalAdvices @include(if: $isLegalAdvisor) {
        category
        level
        message
      }
    }
  }
`
